// extracted by mini-css-extract-plugin
module.exports = {"vGutterX":"30px","background":"ContentBackgroundBottom_background__CNswk","background_widthGutter":"ContentBackgroundBottom_background_widthGutter__3NZRf"};